export default {
    namespaced: true,
    modules: {
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/categories/index.js